import React from 'react';
import cx from 'classnames';

import SectionHeader from '@marketing/components/section_header';
import ValuePropsSection from '@marketing/sections/value_props';

import AITutorIcon from '@marketing/sections/value_props/assets/purple/banner_check_icon.svg';
import PracticeQuestionsIcon from '@marketing/sections/value_props/assets/purple/practice_questions_icon.svg';
import PracticeTestsIcon from '@marketing/sections/value_props/assets/purple/practice_tests_icon.svg';
import ScorePredictorIcon from '@marketing/sections/value_props/assets/purple/score_gauge_icon.svg';
import StudySchedulesIcon from '@marketing/sections/value_props/assets/purple/timely_guidance_icon.svg';
import VideoLessonsIcon from '@marketing/sections/value_props/assets/purple/video_lessons_icon.svg';

import ConcentricCircles from './assets/concentric_circles.svg';
import MagicWandIcon from './assets/magic_wand_icon.svg';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l u-padding-V-xl" style={{ position: 'relative' }}>
      <div
        style={{
          bottom: 0,
          left: '50%',
          position: 'absolute',
          top: 0,
          transform: 'scaleY(-1) translateX(-50%)',
          width: 1130,
          zIndex: -2
        }}
      >
        <img alt="" loading="lazy" src={ConcentricCircles} />
      </div>

      <SectionHeader
        reveal
        subtitle="Thousands of students like you have improved their TOEFL scores"
        supertitle="Everything you need"
        supertitleIcon={MagicWandIcon}
        title="Why you'll love studying with Magoosh"
      />

      <ValuePropsSection
        valueProps={[
          {
            description: "4 official, full-length practice tests directly from ETS",
            icon: PracticeTestsIcon,
            name: "Practice Tests"
          },
          {
            description: "All TOEFL® questions are created by ETS and used under license",
            icon: PracticeQuestionsIcon,
            name: "1300+ Official  Questions"
          },
          {
            description: "Prepare for every section, on any device and 100% online",
            icon: VideoLessonsIcon,
            name: "Expert Video Lessons"
          },
          {
            description: "Get instant score reports showing where you stand and how to improve",
            icon: StudySchedulesIcon,
            name: "Graded Writing/Speaking"
          },
          {
            description: "Never get stuck with an AI tutor to explain any question or concept",
            icon: AITutorIcon,
            name: "AI Tutor"
          },
          {
            description: "Be confident when you're ready with our score predictor tool",
            icon: ScorePredictorIcon,
            name: "Accurate Score Predictor"
          }
        ]}
      />
    </div>
  );
};
